import i18n from '@/shared/i18n';
import BaseModel from "@/core/components/input-widget/BaseModel";
import _ from 'lodash';

export default class DependedFieldSearchModel extends BaseModel {
  title = null;

  attributeLabels = {
    title: i18n.t('Title'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    return data;
  }

  getFilteredData() {
    let returnData = [];

    const data = this.toJSON();

    for (let attr in data) {
      if (data[attr]) {
        let label = this.attributeLabels[attr];
        let value = _.capitalize(data[attr]);
        let text = `${label}: ${value}`;
        returnData.push({text, attr});
      }
    }

    return returnData;
  }
}
